module.exports = __webpack_public_path__ + "img/logo.0d6ef393.svg";